import {useState, useCallback} from 'react'

export {default as NotifyModal} from '../components/notify-modal'

export const useNotifyMeModal = () => {
    const [product, setProduct] = useState(null)

    return {
        product,
        isOpen: product ? true : false,
        onClose: useCallback(() => setProduct(null), []),
        onOpen: setProduct
    }
}
